import { render, staticRenderFns } from "./header.block.pug?vue&type=template&id=1a8af86a&scoped=true&lang=pug&external"
import script from "./header.block.ts?vue&type=script&lang=ts&external"
export * from "./header.block.ts?vue&type=script&lang=ts&external"
import style0 from "./header.block.sass?vue&type=style&index=0&id=1a8af86a&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8af86a",
  null
  
)

export default component.exports